import { render, staticRenderFns } from "./EditEggs.vue?vue&type=template&id=0867dc57"
import script from "./EditEggs.vue?vue&type=script&lang=js"
export * from "./EditEggs.vue?vue&type=script&lang=js"
import style0 from "./EditEggs.vue?vue&type=style&index=0&id=0867dc57&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports